<template>
  <div>
    <div class="hover-list">
      <div style="padding: 1.5em"></div>
     
        <draggable v-model="titles" @start="drag = true" @end="drag = false" v-bind="dragOptions" group="hoverlist">
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <div class="hover-item" v-for="t in titles" :key="t.id">
              <div @click="handleScroll(t.id)">{{ t.title }}</div>
            </div>
          </transition-group>
        </draggable>
      </div>
   
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "hover-list",
  components: { draggable },
  props: {
    groups: Array
  },
  data() {
    return {
      drag: false
    };
  },
  methods: {
    handleScroll(id) {
      let elmt = document.getElementById(id);
      let toScroll = document.getElementById("main-graph-scroll");

      if (elmt) {
        toScroll.scrollTo(0, elmt.offsetTop - window.innerHeight / 3);
      }
    }
  },
  computed: {
    titles: {
      get() {
        return this.groups.map(x => ({ title: x.title, id: x.id }));
      }, 
      set(list) {
        let reorderedList = list.map(x => {
          return this.groups.find(z => z.id === x.id);
        });
        this.$emit("reorderGroups", reorderedList);
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "hoverlist",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.hover-list {
  position: fixed;
  top: 0;
  height: 100%;
  width: 0;
  overflow: hidden;
  overflow-y: auto;
  z-index: 10;
  &:hover {
    width: max-content;
  }
}

.hover-list:before {
  position: fixed;
  content: "➤";
  color: rgb(100, 88, 77);
  width: 5em;
  top: 50%;
  left: -2.25em;
  font-size: 2.5em;
}

.hover-list:hover:before {
  display: none;
}

.hover-item {
  background-color: #f8f9fa;
  margin: 0.2em;
  padding: 0.33em;
  border-radius: 0.5em;
  cursor: pointer;
  border: 1px solid #ccc;
}
</style>
